<script>
    import HeaderProgramSection from './header_program_section.svelte';
    import {
        vcx,
        benifateSectionForVcx,
        vcxForSection,
    } from './program_data.js';
    import BenifateSection from './benifate_section.svelte';
    import Footer from '../landing_page/footer.svelte';
    import ForSection from './for_section.svelte';
    import {speakerSectionVcx} from './mobile_reuse-section/mobile_reuse_section_data';
    import SpeakerSlider from './mobile_reuse-section/speaker_slider.svelte';
    const {title} = rpcjs.props;
    title.set('VCx | Program');

    const speakerBox = [
        {
            src: '/images/vcx_program/Speaker images/Tim Draper, Draper Associates.png',
            name: 'Tim Draper',
            about: 'Draper Associates',
        },
        {
            src: '/images/vcx_program/Speaker images/Steve Jurvetson.png',
            name: 'Steve Jurvetson',
            about: 'Venture Capitalist',
        },
        {
            src: '/images/vcx_program/Speaker images/Andy Tang, Draper Associates.png',
            name: 'Andy Tang',
            about: 'Draper Associates',
        },
        {
            src: '/images/vcx_program/Speaker images/Sid Mofya, Draper Venture Network.png',
            name: 'Sid Mofya',
            about: 'Draper Venture Network',
        },
        {
            src: '/images/vcx_program/Speaker images/Andrew Chen, a16z.png',
            name: 'Andrew Chen',
            about: 'a16z',
        },
    ];
    const openDiv = [];
    let btn;
    const curriculum = [
        {
            image: '/images/vcx_program/Group 15550.svg',
            img_width: '5vw',
            img_left: '5vw',
            heading: 'Know-How',
            width: '5.521vw',
            points: [
                {
                    bullet: 'Learn the fundamentals of the asset class and get a pulse of the market from top active VCs.',
                },
                {
                    bullet:
                        'We choose our speaker lineup so the domain expertise is balanced ' +
                        ' across pioneers of the industry, those at the top of their game, and the rising stars.',
                },
                {
                    bullet:
                        'Additional resources and literature are made available for further reading. As well as ' +
                        ' access to the lectures from all previous sessions.',
                },
            ],
        },
        {
            image: '/images/vcx_program/Group 15561.svg',
            heading: 'Dealflow',
            img_width: ' 5vw',
            img_left: '5vw',
            width: '7.198vw',
            points: [
                {
                    bullet:
                        'As know-how is often difficult to transfer just ' +
                        ' by taking notes, participants have to intensively look at deal flow.',
                },
                {
                    bullet:
                        'Selected startups will pitch participants while ' +
                        ' being coached by a VC on the kinds of questions to ask.',
                },
                {
                    bullet:
                        'To understand how multiple rounds of financing work, we ' +
                        ' do a case study on a venture-backed company on track to IPO.',
                },
            ],
        },
        {
            image: '/images/vcx_program/Group 15497.svg',
            heading: 'Networking',
            img_width: '3.5vw',
            img_left: '6.5vw',
            width: '4.185vw',
            points: [
                {
                    bullet: 'Expect quality networking time with the speakers and your peer participants.',
                },
                {
                    bullet:
                        'Private tours, group lunches and dinners, while staying ' +
                        ' at the same hotel, helps develop camaraderie.',
                },
                {
                    bullet:
                        'Upon graduating you become part of a vibrant investor ' +
                        ' network of global entrepreneurial families and Silicon Valley VCs.',
                },
                {
                    bullet: 'VCx Unplugged, our annual reunion, helps catalyze these relationships.',
                },
            ],
        },
    ];
    // <!-- Google Tag Manager -->
    (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({'gtm.start': new Date().getTime(), 'event': 'gtm.js'});
        const f = d.getElementsByTagName(s)[0];
        const j = d.createElement(s);
        const dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
    // <!-- End Google Tag Manager -->
</script>

<HeaderProgramSection
    data={vcx}
    lineHeight="18.299vw"
    widthDescription="40.516vw"
    colors="white"
    headingTop="-9vw"
    headingLeft="-0.063vw"
    boxTop="38.616vw"
    marginTop="-0.5vw"
    TopMbl="122vw"
    lineHeightMbl="13.299vw"
    discTop="37.5vw"
    hrWidth="12.929"
/>
<div class="desktop">
    <BenifateSection data={benifateSectionForVcx} />
    <div style="position:relative;">
        <div class="circle" />
        <div class="circle" />
        <div class="circle" />
        <div style="width: 83.602vw;margin: 11.905vw auto;padding:0 1vw;">
            <div style="display: flex;">
                <h1
                    style="margin-top: 0.65vw;font-size:1.191vw;opacity: 0.3;margin-right: 2vw;margin-left: -3.7vw;"
                >
                    02
                </h1>
                <h1
                    style="font-size:2.067vw;color:rgba(0, 32, 75, 1);font-weight:500;"
                >
                    CURRICULUM HIGHLIGHTS
                </h1>
            </div>
        </div>
        <div
            style="    width: 88.757vw;
            margin: auto;
            box-shadow: rgb(0 32 75 / 20%) 0vw 0.265vw 2.91vw;
            border-radius: 1.323vw;
            margin-top: -9vw;
            color: rgba(0, 32, 75, 1);
            margin-left: 5.6vw;"
        >
            {#each curriculum as data}
                <div class="list_point">
                    <div style="display:flex;align-items: center;">
                        <div
                            style="margin-left: {data.img_left};width: {data.img_width};"
                        >
                            <img
                                src={data.image}
                                alt=""
                                width="100%"
                                style="width:{data.width};"
                            />
                        </div>
                        <div style="margin-left:9vw;">
                            <h1 style="font-size: 1.984vw; font-weight:600">
                                {data.heading}
                            </h1>
                            <ul style="width:59vw;">
                                {#each data.points as bulletPoint}
                                    <li>
                                        {bulletPoint.bullet}
                                    </li>
                                {/each}
                            </ul>
                        </div>
                    </div>
                </div>
            {/each}
        </div>
        <div>
            <div style="margin:9.294vw 0vw 2.646vw 8.995vw;">
                <h1
                    style="font-size: 2.067vw;
                color: rgba(0, 32, 75, 1);"
                >
                    SPEAKERS
                </h1>
            </div>

            <div style="display: flex;flex-wrap: wrap;justify-content: center;">
                {#each speakerBox as data}
                    <div class="speaker_box">
                        <div>
                            <div
                                style="width:8.532vw;height:8.532vw;border-radius:50%;margin:auto;padding:2vw 1vw"
                            >
                                <img src={data.src} alt="" width="100%" />
                            </div>
                            <div
                                style="margin-top:3.1vw;text-align:center;height: 5.4vw;background-color:#f4f4f4;"
                            >
                                <h1
                                    style="font-size:1.190vw;font-weight: 600;    padding-top: 1.2vw;"
                                >
                                    {data.name}
                                </h1>
                                <h1 style="font-size: 0.926vw;">
                                    {data.about}
                                </h1>
                            </div>
                        </div>
                    </div>
                {/each}
            </div>
        </div>
    </div>
</div>
<div class="mobile">
    <div style="margin-bottom:10vw;margin-top:24.766vw;">
        <div style="display: flex;">
            <h1
                style="color:rgba(0, 32, 75, 1);font-size:2.778vw;margin-left: 5vw;;opacity: 0.3;"
            >
                01
            </h1>
            <div class="circle_mbl">
                <h1
                    style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight: 600; text-transform: uppercase;width: 80vw; margin-left: -10vw; margin-top: 7vw;"
                >
                    What is VCx
                </h1>
                <div style="width: 76.386vw;margin: 4vw 0px 0px -10.5vw;">
                    <p
                        style="font-size: 3.056vw;line-height:4.833vw;text-align:justify;"
                    >
                        The film Something Venture documented the emergence of
                        Silicon Valley venture capitalism. In the mid-20th
                        century, when both terms hadn't even been coined.<br />
                        <br />
                        Today, as entrepreneurship and innovation have become the
                        engine for economic growth, the world of capital investments
                        needs to address a major bottleneck: the lack of VC know-how.
                        Founded in July 2014, VCx is bridging the new generations
                        of entrepreneurial families with the best VCs in Silicon
                        Valley... including some of its founding fathers.
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div
        style="display: flex;align-items:center; margin-left:5.556vw; margin-top: 24.766vw;
         margin-bottom: 5vw;"
    >
        <h1
            class="section1"
            style="color:#00204B;font-size:2.778vw;margin-right:7.061vw; opacity:0.3;"
        >
            02
        </h1>
        <h1
            class="section-title"
            style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600; text-transform: uppercase;"
        >
            Curriculum Highlights
        </h1>
    </div>
    <div style="width: 91.111vw;margin:7vw auto;padding:0 1vw;">
        <div
            style="border-radius:3vw;box-shadow: 0vw 0.265vw 2.912vw rgba(0, 32, 75, 0.2);"
        >
            {#each curriculum as data, i}
                <div class="content-holder">
                    <div
                        style="display: flex;align-items: baseline;padding:3vw;"
                    >
                        <div
                            class="img-wrraper-logo"
                            style="margin-right: 5vw;width:7vw;"
                        >
                            <img src={data.image} alt="" width="100%" />
                        </div>
                        <div>
                            <h1
                                class="section1list"
                                style="font-size: 3.889vw;width: 64vw; font-weight:600;"
                            >
                                {data.heading}
                            </h1>
                        </div>
                        <div style="">
                            <button
                                class="view-all-btn "
                                on:click={() => {
                                    if (openDiv[i].style.display === 'none') {
                                        openDiv[i].style.display = 'block';
                                        btn.style.transform = 'rotate(180deg)';
                                    } else {
                                        openDiv[i].style.display = 'none';
                                        btn.style.transform = 'rotate(0deg)';
                                    }
                                }}
                            >
                                <img
                                    bind:this={btn}
                                    src="/images/Hero_section/drop_down.svg"
                                    alt=""
                                    width="100%"
                                />
                            </button>
                        </div>
                    </div>

                    <div
                        class="open_div"
                        style="width: 75vw;margin: 3vw auto 2vw auto;"
                        bind:this={openDiv[i]}
                    >
                        <div style="">
                            <ul
                                class="points"
                                style="
                                margin-top:2vw;
                                width: 70vw;
                                margin-left: 4vw;padding-bottom: 2vw;"
                            >
                                {#each data.points as bulletMbl}
                                    <li>
                                        <p
                                            style="font-size:3.056vw;line-height:3.068vw;"
                                        >
                                            {bulletMbl.bullet}
                                        </p>
                                    </li>
                                {/each}
                            </ul>
                        </div>
                    </div>
                </div>
            {/each}
        </div>
    </div>
    <div
        style="display: flex;align-items:center; margin-left:15.833vw; margin-top: 10vw;
         margin-bottom: 5vw;"
    >
        <h1
            class="section-title"
            style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600; text-transform: uppercase;"
        >
            Speakers
        </h1>
    </div>
    <SpeakerSlider data={speakerSectionVcx} backColor="#f4f4f4" />
</div>
<ForSection
    data={vcxForSection}
    headingTop="16.6vw"
    marginFor="-7vw"
    headingLeft="5.95vw"
/>
<div class="desktop">
    <div
        style="
        background: linear-gradient(1.05deg, rgb(0, 32, 75) 25.19%, rgb(0, 66, 155) 69.35%);
        padding: 1vw 1vw 4vw 1vw;    margin-top: 13.56vw;
        margin-bottom: -0.2vw;position:relative;
    "
    >
        <div
            style="width: 89.602vw;
        padding: 0px 1vw;"
        >
            <div style="display: flex;">
                <h1
                    style="color: white;
                    font-size: 1.191vw;
                    opacity: 0.6;
                    padding: 5.746vw 6.019vw 0vw 4.886vw;"
                >
                    04
                </h1>
                <h1
                    style="color: rgba(255, 255, 255, 0.2);
                    font-size: 7.942vw;line-height: 7.937vw;
                    font-weight: 700;
                    padding-top: 4.952vw;"
                >
                    Sessions are Invites Only
                </h1>
            </div>
            <div>
                <button
                    class="btn-css"
                    style="position: absolute;top: 18.188vw;left: 42.4vw;"
                    on:click={() => (location.href = './contact_us')}
                    >Request an Invitation</button
                >
            </div>
        </div>
    </div>
</div>
<div class="mobile">
    <div
        style="background: linear-gradient(1.05deg, rgb(0, 32, 75) 25.19%, rgb(0, 66, 155) 68.35%);padding:1vw;    margin-top: 28vw;"
    >
        <div style="width: 83.602vw;margin:7vw auto 0vw;padding:0 1vw;">
            <h1
                style="color:white;font-size:2.778vw;margin-right:5.833vw; opacity:0.3;"
            >
                04
            </h1>
            <h1
                style="color:rgba(255, 255, 255, 0.2);font-size:16.667vw;font-weight:bolder;text-align: center;"
            >
                Sessions <br /> are Invites <br /> Only
            </h1>
            <button
                style="border-radius:8.333vw;border:none;background-color:#F7E05F;font-size:3.611vw; font-weight:500;        height: 10.556vw;
                width: 52.222vw;margin-top: 8vw;margin-left: 17vw;"
                on:click={() => (location.href = './contact_us')}
                >Request an Invitation</button
            >
        </div>
    </div>
</div>
<Footer />

<style>
    .speaker_box::after {
        content: "";
        height: 1.19vw;
        width: 1.19vw;
        background: #f7e05f;
        position: absolute;
        bottom: -0.8vw;
        z-index: 1;
        border-radius: 5vw;
        left: 0.1vw;
    }
    .btn-css {
        background-color: #f7e05f;
        border-radius: 1.984vw;
        color: #00204b;
        font-weight: 500;
        border: none;
        width: 14.683vw;
        height: 3.638vw;
        font-size: 1.19vw;
    }
    .btn-css:hover {
        background-color: transparent;
        border: 0.194vw solid white;
        color: white;
        width: 14.683vw;
        height: 3.638vw;
        font-weight: 500;
        font-size: 1.19vw;
    }
    .speaker_box {
        width: 16.667vw;
        height: 17.394vw;
        border: 0.198vw solid #7cc1ff;
        border-right: none;
        position: relative;
    }
    .speaker_box:nth-child(4) {
        border-right: 0.198vw solid #7cc1ff;
    }
    .speaker_box:nth-child(8) {
        border-right: 0.198vw solid #7cc1ff;
        border-bottom: 0.198vw solid #7cc1ff;
        border-bottom-right-radius: 1vw;
    }
    .speaker_box:nth-child(5) {
        border-right: 0.198vw solid #7cc1ff;
        border-left: none;
        border-top-right-radius: 1vw;
    }
    .speaker_box:nth-child(1) {
        border-top-left-radius: 1vw;
    }
    .list_point {
        padding: 2vw 0;
        background-color: white;
    }
    .list_point:nth-child(odd) {
        background-color: rgba(226, 242, 255, 1);
    }
    .list_point:nth-child(1) {
        border-top-left-radius: 1.323vw;
        border-top-right-radius: 1.323vw;
    }
    .list_point:nth-child(3) {
        border-bottom-left-radius: 1.323vw;
        border-bottom-right-radius: 1.323vw;
    }
    ul li {
        font-size: 1.19vw;
        margin-bottom: 0.926vw;
        line-height: 1.5vw;
    }
    ul li::marker {
        color: #3c88c3;
    }
    .circle_mbl {
        width: 61.951vw;
        height: 102.5vw;
        padding: 5vw 0 0 4vw;
        border: 0.833vw solid rgba(124, 193, 255, 1);
        border-top-right-radius: 8vw;
        border-bottom-right-radius: 8vw;
        border-left: none;
        position: relative;
        margin-left: 12.516vw;
        margin-top: 1vw;
    }
    .circle_mbl::before {
        content: " ";
        position: absolute;
        top: -2.5vw;
        left: 4vw;
        height: 3.919vw;
        width: 3.919vw;
        background-color: rgba(247, 224, 95, 1);
        border-radius: 50%;
    }
    .circle {
        height: 24.802vw;
        width: 24.802vw;
        background-color: rgba(60, 136, 195, 0.33);
        opacity: 0.4;
        border-radius: 50%;
        margin-left: -16.2vw;
        z-index: -1;
    }
    .circle:nth-child(1) {
        position: absolute;
        top: -5vw;
    }
    .circle:nth-child(2) {
        position: absolute;
        top: 5.8vw;
    }
    .circle:nth-child(3) {
        position: absolute;
        top: 14.5vw;
    }
    .desktop {
        display: block;
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
    }
    .content-holder:nth-child(odd) {
        background-color: rgba(226, 242, 255, 1);
    }
    .content-holder:nth-child(1) {
        border-top-left-radius: 3vw;
        border-top-right-radius: 3vw;
    }
    .view-all-btn {
        border: none;
        background-color: transparent;
        width: 3.2vw;
    }
    ul {
        padding: 0;
        margin: 0;
        margin-top: 1.323vw;
    }
    .points li::marker {
        color: #7cc1ff;
        font-size: 4.056vw;
    }
    .open_div {
        display: none;
    }
</style>
